export const EMPTY_LAYOUT_BANDEIRAS_PRODUCT = "";

export const LAYOUT_BANDEIRAS_QUERY_KEY = "layoutBandeiras" as const;

type LayoutBandeirasProductState = {
  lngProposta?: number;
  strProduto?: string;
  strBandeira?: string;
};

export const normalizeLayoutBandeirasProductParam = (
  strProduto?: string | null
): string => strProduto?.trim() || EMPTY_LAYOUT_BANDEIRAS_PRODUCT;

export const hasLayoutBandeirasProduct = (strProduto?: string | null) =>
  Boolean(normalizeLayoutBandeirasProductParam(strProduto));

export const getConsultarLayoutBandeirasParams = (
  strProduto?: string | null
) => ({
  strProduto: normalizeLayoutBandeirasProductParam(strProduto)
});

export const getLayoutBandeirasQueryKey = (strProduto?: string | null) =>
  [
    LAYOUT_BANDEIRAS_QUERY_KEY,
    normalizeLayoutBandeirasProductParam(strProduto)
  ] as const;

export const shouldConsultLayoutBandeiras = (
  strProduto?: string | null,
  additionalEnabled = true
) => hasLayoutBandeirasProduct(strProduto) && additionalEnabled;

const hasCommittedProposal = (lngProposta?: number) =>
  typeof lngProposta === "number" && lngProposta > 0;

export const sanitizeLayoutBandeirasProductState = (
  proposalData?: LayoutBandeirasProductState
): { strProduto: string; strBandeira?: string } => {
  if (!hasCommittedProposal(proposalData?.lngProposta)) {
    return {
      strProduto: EMPTY_LAYOUT_BANDEIRAS_PRODUCT,
      strBandeira: undefined
    };
  }

  return {
    strProduto: normalizeLayoutBandeirasProductParam(proposalData?.strProduto),
    strBandeira: proposalData?.strBandeira
  };
};

export const shouldFetchLayoutBandeirasWhenBandeiraMissing = (
  strProduto?: string | null,
  strBandeira?: string | null
) => shouldConsultLayoutBandeiras(strProduto) && !strBandeira?.trim();

export const mergePreProposalPersistedState = <
  T extends { proposalData?: LayoutBandeirasProductState }
>(
  persistedState: unknown,
  currentState: T
): T => {
  const persisted = (persistedState ?? {}) as Partial<T>;
  const persistedProposalData = persisted.proposalData;

  return {
    ...currentState,
    ...persisted,
    proposalData: {
      ...(currentState.proposalData ?? {}),
      ...(persistedProposalData ?? {}),
      ...sanitizeLayoutBandeirasProductState(persistedProposalData)
    }
  };
};
